import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "team-order-view d-flex" }
const _hoisted_2 = { class: "select-box" }
const _hoisted_3 = { class: "d-flex justify-center pa-4 bg-blue-lighten-1" }
const _hoisted_4 = { class: "tile-rank" }

import {ref, watch} from "vue";
import {useApi} from "@/api/handler";
import {game, proposal} from "@/api";
import {ApiMap} from "@/api/type";
import {splitThree} from "@/utils/random";
import InitDelete from "@/components/proposal/init/InitDelete.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TeamOrder',
  props: {
    data: {}
  },
  emits: ['update'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const GameStatus = ref<ApiMap['/game/status/:id']['resp'] | null>(null)
const tabValue = ref<number>(1)
const tileRank = ref<ApiMap['/game/rank/team/:id']['resp']>([])
const selectedTeam = ref<Array<Array<{teamId: string, teamLeader: string, check: boolean}>>>([[], [], []])
const removedList = ref<Array<number>>([])
const pageSize = ref<number>(100)

const headers = [
  {title: '组号', value: 'teamId', align: 'center'},
  {title: '组长', value: 'teamLeader', align: 'center'},
  {title: '选择', value: 'check'}
]

function GetMaxSelected(num: number) {
  if (!GameStatus.value) return 0
  return splitThree(GameStatus.value.teamCount - removedList.value.length)[num - 1]
}

const useTileRank = () => {
  if (!props.data) return
  useApi({
    api: game.TileRank(props.data.id),
    onSuccess: resp => {
      tileRank.value = (resp.data as ApiMap['/game/rank/team/:id']['resp'])
          .filter(item => !removedList.value.includes(item.teamId))
      selectedTeam.value[0] = tileRank.value
          .sort((a, b) => a.teamId - b.teamId)
          .map((item: any) => ({teamId: `第 ${item.teamId} 组`, teamLeader: item.leaderName, check: false}))
      selectedTeam.value[1] = tileRank.value
          .sort((a, b) => a.teamId - b.teamId)
          .map((item: any) => ({teamId: `第 ${item.teamId} 组`, teamLeader: item.leaderName, check: false}))
      selectedTeam.value[2] = tileRank.value
          .sort((a, b) => a.teamId - b.teamId)
          .map((item: any) => ({teamId: `第 ${item.teamId} 组`, teamLeader: item.leaderName, check: false}))
    }
  })
}

const useSubmitOrder = () => {
  if (!GameStatus.value) return
  useApi({
    api: proposal.SubmitOrder({
      gameId: GameStatus.value?.id,
      roundTeamIds: selectedTeam.value.map(
              item => item
                  .filter(i => i.check)
                  .map(n => +n.teamId.replace('第', '').replace('组', '').trim())
          )
    }),
    onSuccess: () => {emits('update')},
    tip: '上传成功'
  })
}

const useRemovedList = () => {
  if (!GameStatus.value) return
  useApi({
    api: game.RemoveList(GameStatus.value.id),
    onSuccess: resp => {
      removedList.value = resp.data as Array<number>
      useTileRank()
    }
  })
}

watch(() => props.data, () => {
  GameStatus.value = props.data ?? null
  useTileRank()
  useRemovedList()
}, {immediate: true})

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_tabs, {
        modelValue: tabValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tabValue).value = $event)),
        color: "deep-purple-accent-4",
        class: "ml-6",
        height: "60px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, { value: 1 }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("第一轮")
            ])),
            _: 1,
            __: [4]
          }),
          _createVNode(_component_v_tab, { value: 2 }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("第二轮")
            ])),
            _: 1,
            __: [5]
          }),
          _createVNode(_component_v_tab, { value: 3 }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("第三轮")
            ])),
            _: 1,
            __: [6]
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_tabs_window, {
        modelValue: tabValue.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tabValue).value = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3], (num) => {
            return _createVNode(_component_v_tabs_window_item, {
              value: num,
              class: "my-6 mx-8",
              key: num
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  height: "480",
                  style: {"overflow-y":"auto"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, "第 " + _toDisplayString(num) + " 轮共 " + _toDisplayString(GetMaxSelected(num)) + " 组, 还可选择 " + _toDisplayString(GetMaxSelected(num)-selectedTeam.value[num - 1].filter((item) => item.check).length) + " 组 ", 1),
                    _createVNode(_component_v_data_table, {
                      "hide-default-footer": "",
                      items: selectedTeam.value[num - 1],
                      "item-value": "teamId",
                      headers: headers,
                      "items-per-page": pageSize.value,
                      "onUpdate:itemsPerPage": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event))
                    }, {
                      "item.check": _withCtx(({ item }) => [
                        _createVNode(_component_v_checkbox_btn, {
                          disabled: selectedTeam.value[num - 1].filter((item) => item.check).length >= GetMaxSelected(num),
                          modelValue: item.check,
                          "onUpdate:modelValue": ($event: any) => ((item.check) = $event),
                          ripple: false
                        }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["items", "items-per-page"])
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_btn, {
                  class: "mt-6",
                  color: "red-lighten-2",
                  block: "",
                  onClick: ($event: any) => (selectedTeam.value[num - 1].forEach((item) => item.check = false))
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("重置")
                  ])),
                  _: 2,
                  __: [7]
                }, 1032, ["onClick"]),
                _createVNode(_component_v_btn, {
                  class: "mt-3",
                  color: "primary",
                  block: "",
                  onClick: useSubmitOrder
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode("提交")
                  ])),
                  _: 1,
                  __: [8]
                })
              ]),
              _: 2
            }, 1032, ["value"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(InitDelete, {
        "max-height": "700",
        class: "ma-4",
        data: GameStatus.value,
        onUpdate: _cache[3] || (_cache[3] = ($event: any) => (emits('update')))
      }, null, 8, ["data"])
    ])
  ]))
}
}

})